import React, { Component } from 'react'

import { connect } from 'react-redux'

import Loading from './components/shared/Loading'

import { isLoading } from './auth/selectors'
import { initAuth } from './auth/actions'

import './app.scss'

export class AppInitializer extends Component {
  componentDidMount() {
    this.props.initAuth()
  }

  render() {
    const { isLoading, children } = this.props

    if (isLoading) {
      return (
        <div className="loading-app-overlay">
          <Loading classes="loading" />
        </div>
      )
    }

    return children
  }
}

const mapStateToProps = state => ({
  isLoading: isLoading(state),
})

const mapDispatchToProps = {
  initAuth
}

export default connect(mapStateToProps, mapDispatchToProps)(AppInitializer)
